<template lang="pug">
.completed-forms(
  v-if="completedForms.length > 0"
  :class="{ 'with-header': showHeader }"
)
  .section-header(v-if="showHeader")
    h4 {{ headerTitle }}
  .completed-form(
    v-for="(completedForm, index) in completedForms"
    :key="completedForm._id || index"
  )
    .form-info
      span.form-name {{ completedForm.name || completedForm.form?.name }}
      span.form-date {{ formatFormDate(completedForm.createdAt) }}
    .form-actions
      .sent-indicator(v-if="completedForm.isSent")
        i.el-icon-check(style="color: #67c23a; font-size: 18px;")
        span.sent-text(style="color: #67c23a; font-size: 12px; margin-left: 4px;") Enviado
      .form-buttons(v-else-if="!readonly")
        button.button.button--blue(
          @click="onEditCompletedForm(completedForm)"
        )
          i.el-icon-edit
        button.button.button--red(
          @click="onRemoveCompletedForm(completedForm)"
        )
          i.el-icon-delete
</template>

<script>
export default {
  name: "CompletedFormsList",
  props: {
    completedForms: {
      type: Array,
      default: () => [],
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    headerTitle: {
      type: String,
      default: "Formularios completados",
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatFormDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    onEditCompletedForm(completedForm) {
      this.$emit("edit-completed-form", completedForm);
    },

    onRemoveCompletedForm(completedForm) {
      this.$emit("remove-completed-form", completedForm);
    },
  },
};
</script>

<style lang="scss" scoped>
.completed-forms {
  margin-top: 10px;

  &:not(.with-header) {
    margin-top: 0;
  }
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: solid 2px $steel-blue;
  padding-bottom: 6px;
  margin-bottom: 10px;
  margin-top: 10px;

  h4 {
    font-size: 13px;
    font-weight: 600;
  }
}

.completed-form {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  margin-bottom: 8px;
  background-color: #f5f7fa;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
}

.form-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.form-name {
  color: #303133;
  font-size: 14px;
}

.form-date {
  font-size: 12px;
  color: #909399;
}

.form-actions {
  display: flex;
  gap: 8px;
}

.sent-indicator {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  background-color: #f0f9ff;
  border-radius: 4px;
  border: 1px solid #67c23a;
}

.form-buttons {
  display: flex;
  gap: 8px;
}

.button i {
  font-size: 16px;
  line-height: 1;
  vertical-align: middle;
  margin: 0;
  padding: 0;
  transition: transform 0.175s linear;
}

.button:hover i {
  transform: rotate(90deg);
}
</style>
